import request from '@/server/request'
export default {
  async loadBanners ({ rootGetters }) {
    return request({ entity: 'settings.banners', action: 'list' }, rootGetters['admin/getAccessToken'], 'GET')
  },

  loadBanner ({ rootGetters }, payload) {
    return request({ entity: 'settings.banners', action: 'get' }, rootGetters['admin/getAccessToken'], 'GET', payload)
  },

  create ({ rootGetters }, payload) {
    return request({ entity: 'settings.banners', action: 'create' }, rootGetters['admin/getAccessToken'], 'POST', payload, false, true)
  },

  update ({ rootGetters }, payload) {
    return request({ entity: 'settings.banners', action: 'update' }, rootGetters['admin/getAccessToken'], 'PUT', payload, false, true)
  },

  delete ({ rootGetters }, payload) {
    return request({ entity: 'settings.banners', action: 'delete' }, rootGetters['admin/getAccessToken'], 'DELETE', payload)
  },
}
